import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { api } from '../services/api';

export default function Profile() {
  const { user, refreshProfile } = useAuth();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (user) {
      setFormData({
        dealership_name: user.dealership_name || '',
        dba_name: user.dba_name || '',
        street_address: user.street_address || '',
        city: user.city || '',
        state: user.state || '',
        zip_code: user.zip_code || '',
        phone: user.phone || '',
        website: user.website || '',
        primary_contact_name: user.primary_contact_name || '',
        primary_contact_email: user.primary_contact_email || '',
        primary_contact_phone: user.primary_contact_phone || '',
        primary_contact_role: user.primary_contact_role || '',
        tax_id: user.tax_id || '',
        dms_system: user.dms_system || '',
      });
    }
  }, [user]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      await api.updateProfile(formData);
      await refreshProfile();
      setMessage('Profile updated successfully!');
    } catch (err) {
      setMessage('Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Dealership Profile</h2>

      {message && (
        <div className={`alert ${message.includes('Error') ? 'alert-error' : 'alert-success'}`}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="card">
          <h3>Business Information</h3>
          <div className="form-row">
            <div className="form-group">
              <label>Dealership Name</label>
              <input name="dealership_name" value={formData.dealership_name} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>DBA Name</label>
              <input name="dba_name" value={formData.dba_name} onChange={handleChange} />
            </div>
          </div>
          <div className="form-group">
            <label>Street Address</label>
            <input name="street_address" value={formData.street_address} onChange={handleChange} />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>City</label>
              <input name="city" value={formData.city} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>State</label>
              <input name="state" value={formData.state} onChange={handleChange} />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>ZIP Code</label>
              <input name="zip_code" value={formData.zip_code} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input name="phone" value={formData.phone} onChange={handleChange} />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Website</label>
              <input name="website" value={formData.website} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Tax ID</label>
              <input name="tax_id" value={formData.tax_id} onChange={handleChange} />
            </div>
          </div>
          <div className="form-group">
            <label>DMS System</label>
            <input name="dms_system" value={formData.dms_system} onChange={handleChange} placeholder="e.g., CDK, Reynolds, DealerTrack" />
          </div>
        </div>

        <div className="card">
          <h3>Primary Contact</h3>
          <div className="form-row">
            <div className="form-group">
              <label>Name</label>
              <input name="primary_contact_name" value={formData.primary_contact_name} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Role</label>
              <input name="primary_contact_role" value={formData.primary_contact_role} onChange={handleChange} />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Email</label>
              <input type="email" name="primary_contact_email" value={formData.primary_contact_email} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input name="primary_contact_phone" value={formData.primary_contact_phone} onChange={handleChange} />
            </div>
          </div>
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Saving...' : 'Save Changes'}
        </button>
      </form>
    </div>
  );
}
